import { ArrowLeft, ClipboardList, Compass, Home, Zap } from 'lucide-react';

/** Full-bleed fallback for an unknown browser path or an invalid manager page.
 * It deliberately does not depend on a loaded save, so it remains useful
 * before login and after opening a stale bookmark. */
export function NotFoundPage() {
  return <main className="not-found-page">
    <div className="not-found-stadium" aria-hidden="true"><i className="not-found-lightning lightning-one" /><i className="not-found-lightning lightning-two" /><i className="not-found-energy energy-one" /><i className="not-found-energy energy-two" /></div>
    <section className="not-found-panel" aria-labelledby="not-found-title">
      <img className="not-found-logo" src="/inazuma_manager_eleven.png" alt="Inazuma Manager Eleven" />
      <span className="not-found-commentary"><Zap size={14} /> MINUTO 90+4 · EL BALÓN DESAPARECIÓ POR LA BANDA…</span>
      <p className="not-found-code" aria-label="Error 404">404</p>
      <h1 id="not-found-title">Balón fuera del campo</h1>
      <p className="not-found-copy">La jugada que buscas no existe.<br />Quizá el pase fue demasiado fuerte.</p>
      <nav className="not-found-actions" aria-label="Navegación de recuperación">
        <a className="not-found-primary" href="/"><Home size={17} /> Volver al inicio</a>
        <a href="/manager"><Compass size={17} /> Ir al manager</a>
        <a href="/manager/squad"><ClipboardList size={17} /> Ver plantilla</a>
      </nav>
      <a className="not-found-back" href="/"><ArrowLeft size={14} /> Recuperar la jugada</a>
    </section>
  </main>;
}
